export default [
	{
		id: 1,
		name: "Hooker",
		short_name: "HOK",
		plural: "Hooker",
		full_name: "Hooker"
	},
	{
		id: 2,
		name: "Middle",
		short_name: "MID",
		plural: "Middle Forward",
		full_name: "Middle Forward"
	},
	{
		id: 3,
		name: "Edge",
		short_name: "EDG",
		plural: "Edge Forward",
		full_name: "Edge Forward"
	},
	{
		id: 4,
		name: "Halves",
		short_name: "HLF",
		plural: "Half",
		full_name: "Half"
	},
	{
		id: 5,
		name: "Centres",
		short_name: "CTR",
		plural: "Centre",
		full_name: "Centre"
	},
	{
		id: 6,
		name: "Wing / Fullbacks",
		short_name: "WFB",
		plural: "Wing / Full Back",
		full_name: "Wing / Fullback"
	}
];


// WEBPACK FOOTER //
// ./src/helpers/positions/index.js